<template>
  <li class="menu-item">
    <a href="#" @click.prevent="click"><t-icon :name="`icon-color ${color}`" /></a>
    <ul class="sub-menu-items" :style="submenuStyle">
      <li class="sub-menu-item"><a href="#" @click.prevent="setColor('green');click()"><t-icon name="icon-color green" /></a></li>
      <li class="sub-menu-item"><a href="#" @click.prevent="setColor('red');click()"><t-icon name="icon-color red" /></a></li>
      <li class="sub-menu-item"><a href="#" @click.prevent="setColor('blue');click()"><t-icon name="icon-color blue" /></a></li>
      <li class="sub-menu-item"><a href="#" @click.prevent="setColor('pink');click()"><t-icon name="icon-color pink" /></a></li>
      <li class="sub-menu-item"><a href="#" @click.prevent="setColor('yellow');click()"><t-icon name="icon-color yellow" /></a></li>
      <li class="sub-menu-item"><a href="#" @click.prevent="setColor('black');click()"><t-icon name="icon-color black" /></a></li>
    </ul>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      open: false
    }
  },
  methods: {
    ...mapActions(['setColor']),
    click (event) {
      if (event) {
        event.preventDefault()
      }
      this.open = !this.open
    }
  },
  computed: {
    ...mapGetters(['color']),
    submenuStyle () {
      return {
        'min-width': `${5 * 55}px`
      }
    }
  },
  watch: {
    open (newVal) {
      this.$el.classList.toggle('open')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MenuItemColorSelect.vue